import React from 'react';

import { TFileSection } from '../../types';

import {
  Wrapper,
  Description,
  StyledButtonTab,
  Title,
} from './SidePanel.styles';

export interface ISidePanelOption {
  title: string;
  value: string;
  iconName?: string;
}

interface ISidePanelProps {
  options: ISidePanelOption[];
  selected: TFileSection;
  onSelect: Function;
  className?: string;
}

export const SidePanel = ({
  className,
  options,
  onSelect,
  selected,
}: ISidePanelProps) => {
  return (
    <Wrapper className={className}>
      <Description>
        <Title>Document types</Title>
      </Description>
      {options.map(({ title, value }) => {
        return (
          <StyledButtonTab
            key={title}
            onClick={() => onSelect(value)}
            isSelected={value === selected}
          >
            {title}
          </StyledButtonTab>
        );
      })}
    </Wrapper>
  );
};

export default SidePanel;
